import { Component, ContentChild, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'risk-pill',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './risk-pill.component.html',
  styleUrls: ['./risk-pill.component.css'],
})
export class RiskPillComponent implements OnInit {
  @ContentChild('content') contentElement!: Element;
  constructor() {}

  ngOnInit(): void {}
}
